module.exports = __webpack_public_path__ + "img/apps.1bb0aef0.svg";